var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6C14 8.20914 12.2091 10 10 10C7.79086 10 6 8.20914 6 6C6 3.79086 7.79086 2 10 2C12.2091 2 14 3.79086 14 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4286 14.75C15.9492 14.75 14.75 15.9492 14.75 17.4286C14.75 18.9079 15.9492 20.1071 17.4286 20.1071C18.1684 20.1071 18.8371 19.8082 19.3226 19.3226C19.8082 18.8371 20.1071 18.1684 20.1071 17.4286C20.1071 15.9492 18.9079 14.75 17.4286 14.75ZM13.25 17.4286C13.25 15.1208 15.1208 13.25 17.4286 13.25C19.7363 13.25 21.6071 15.1208 21.6071 17.4286C21.6071 18.3112 21.3329 19.1306 20.8658 19.8052L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L19.8052 20.8658C19.1306 21.3329 18.3112 21.6071 17.4286 21.6071C15.1208 21.6071 13.25 19.7363 13.25 17.4286Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2752 21.301C12.329 20.2866 11.75 18.9252 11.75 17.4286C11.75 14.8741 13.4367 12.7136 15.7571 12H4C2.89543 12 2 12.8954 2 14C2 18.4183 5.58172 22 10 22C11.1669 22 12.2755 21.7501 13.2752 21.301Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSearch);
export default __webpack_public_path__ + "static/media/user-search.95fe672e3c4f97317ad03135e9224d1f.svg";
export { ForwardRef as ReactComponent };